import { render } from "./UsersView.vue?vue&type=template&id=f2557c52"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__